import React from 'react';

export const SmsStatsCards = ({ stats }) => {
    if (!stats) return null;

    const cards = [
        {
            label: 'Total SMS',
            value: stats.total || 0,
            colorClass: 'primary'
        },
        {
            label: 'Entregados',
            value: stats.entregados || 0,
            colorClass: 'success',
            subtitle: stats.tasaEntrega ? `${stats.tasaEntrega}%` : '0%',
            subtitleClass: 'success'
        },
        {
            label: 'Pendientes',
            value: stats.pendientes || 0,
            colorClass: 'warning'
        },
        {
            label: 'Fallidos',
            value: stats.fallidos || 0,
            colorClass: 'danger'
        }
    ];

    return (
        <div className='sms-stats-cards'>
            {cards.map((card, index) => (
                <div key={index} className='stat-card'>
                    <div className={`stat-value ${card.colorClass}`}>
                        {card.value}
                    </div>
                    <div className='stat-label'>
                        {card.label}
                    </div>
                    {card.subtitle && (
                        <div className={`stat-subtitle ${card.subtitleClass || ''}`}>
                            {card.subtitle}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};